import { useTranslation } from 'react-i18next';
import { UserRole } from '../../../shared/VolunteerApplicationServiceTypes';
import { Button, Typography } from 'antd';
import { useCallback } from 'react';
import Icon from '../../../components/ui-components/Icon';
import RightArrowWhite from '../../../assets/images/arrow-right-white.svg';
import { useAddOrEditFunctionaryPage } from '../AddOrEditFunctionaryPage/useAddOrEditFunctionaryPage';
import useUserSession from '../../../hooks/useUserSession';
import { PositionAssignmentUser } from '../../../shared/MySrcm';
import { getDisplayGender } from '../../../shared/Utils';
const { Text } = Typography;

interface FunctionaryCardProps extends PositionAssignmentUser {
	onEditClick: (functionary: PositionAssignmentUser) => void;
}

export const FunctionaryCard = (props: FunctionaryCardProps) => {
	const {
		name,
		email,
		gender,
		mobile,
		ref,
		srcm_group: srcmGroup,
		assignments,
		onEditClick,
	} = props;
	const { t } = useTranslation();
	const { selectedRole } = useUserSession();
	const { addOrEditFormStatus } = useAddOrEditFunctionaryPage();

	const displayFunctionariesType = selectedRole === UserRole.SNP_ADMIN;

	const handleEditClick = useCallback(() => {
		addOrEditFormStatus();
		onEditClick(props);
	}, [onEditClick, props, addOrEditFormStatus]);

	const getFunctionaryType = useCallback(() => {
		if (!assignments?.length) {
			return '-';
		}

		return assignments
			.map((assignment) => assignment.position?.name)
			.filter(Boolean)
			.join(', ');
	}, [assignments]);

	return (
		<>
			<div className="flex flex-col rounded-lg border border-solid border-gray-300 bg-bground-blue p-[16px] py-[24px]">
				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('name')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{name}</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('email')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{email}</Text>
					</div>
				</div>

				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('gender')}</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{getDisplayGender(gender)}
						</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('mobile')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{mobile}</Text>
					</div>
				</div>

				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('SRCMID')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{ref}</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('homeZone')}</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{srcmGroup?.name || '-'}
						</Text>
					</div>
				</div>

				{displayFunctionariesType && (
					<div className="flex flex-row gap-6 mb-4">
						<div className="flex flex-col gap-1 w-[50%]">
							<Text className="text-light-gray text-sm">
								{t('functionaryType')}
							</Text>
							<Text className="text-gray-650 text-sm font-bold">
								{getFunctionaryType()}
							</Text>
						</div>
					</div>
				)}

				<div className="flex justify-center">
					<Button type="primary" onClick={handleEditClick} className="w-full">
						<span className="flex gap-2">
							{t('editOrUpdate')}
							<Icon src={RightArrowWhite} width="w-4" height="h-4" />
						</span>
					</Button>
				</div>
			</div>
		</>
	);
};
